// extracted by mini-css-extract-plugin
export default {"container":"bVUGdxOcYhB2Z32pHVgI","option":"fcpb7GrzgQoRdS_bV0ex","optionTitle":"OZaiR0kYPcYsXEDbvq2U","optionDescription":"LduK6WAZGBXITynzkatJ"};